import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import parse from "html-react-parser";
import { dateTimeFormat } from "../../../util/DateUtil";

export default function ComunicadoUsuarioForm({
  comunicadoUsuario,
  handleConfirmRead,
  isConfirming = false,
}) {
  const { comunicado } = comunicadoUsuario;

  return (
    <Box maxWidth={860} mx="auto">
      <Stack spacing={3}>
        {comunicado.comunicadoBanner && (
          <Box
            component="img"
            src={comunicado.comunicadoBanner.urlBanner}
            alt="Banner do comunicado"
            sx={{
              width: "100%",
              maxHeight: 400,
              objectFit: "contain",
              borderRadius: 2,
              bgcolor: "action.hover",
            }}
          />
        )}

        <Stack spacing={1.5}>
          <Typography variant="h5" fontWeight={600}>
            {comunicado.titulo}
          </Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
            {comunicado.categoria && (
              <Chip size="small" variant="outlined" label={comunicado.categoria.descricao} />
            )}
            {comunicado.dataHoraPara && (
              <Chip
                size="small"
                color="warning"
                icon={<EventOutlinedIcon />}
                label={`Para: ${dateTimeFormat(comunicado.dataHoraPara)}`}
              />
            )}
            {comunicadoUsuario.createdAt && (
              <Typography variant="body2" color="text.secondary">
                Enviado em {dateTimeFormat(comunicadoUsuario.createdAt)}
              </Typography>
            )}
            {comunicadoUsuario.aluno && (
              <Typography variant="body2" color="text.secondary">
                · Aluno: {comunicadoUsuario.aluno.nome}
              </Typography>
            )}
          </Stack>
        </Stack>

        <Divider />

        <Box sx={{ "& img": { maxWidth: "100%", height: "auto" }, overflowWrap: "anywhere" }}>
          {comunicado.descricao ? parse(comunicado.descricao) : ""}
        </Box>

        <Divider />

        {comunicadoUsuario.leituraConfirmada ? (
          <Alert severity="success">Leitura confirmada.</Alert>
        ) : (
          <Box>
            <Button
              variant="contained"
              color="success"
              size="large"
              startIcon={<CheckIcon />}
              disabled={!comunicadoUsuario.usuario || isConfirming}
              onClick={handleConfirmRead}
            >
              Confirmar Leitura
            </Button>
          </Box>
        )}
      </Stack>
    </Box>
  );
}
